module.exports = __webpack_public_path__ + "4e26fac1793ee9a45e9779d0081b7b47.svg";